<template>
    <div
        :style="[docStyle, widgetTitleColorStyle]"
        :class="['xe-dashboard ' + (isFullScreen ? ' m-auto m-l-40 m-r-40 m-t-20' : '')]"
    >
        <!-- 에디트모드 툴박스 -->
        <vvo v-slot="v" ref="dashboardVal" style="width: 450px">
            <div class="row m-r-1 m-l-1">
                <div class="col-lg-12 bg-white m-b-20 p-10" v-if="isEditMode">
                    <div class="btn-group">
                        <button
                            class="btn btn-white"
                            @click="customValidate() && onValidate(v, onSave)"
                            v-b-tooltip.hover
                            :title="$t('대시보드 저장')"
                        >
                            <i class="fas fa-save"></i> {{ $t("저장") }}
                        </button>
                        <button
                            class="btn btn-white"
                            @click="openSaveAsPopup()"
                            v-b-tooltip.hover
                            :title="$t('대시보드 다른 이름으로 저장')"
                        >
                            <i class="fas fa-copy"></i> {{ $t("다른 이름으로 저장") }}
                        </button>
                        <button
                            class="btn btn-white"
                            @click="openAnalysisModal()"
                            v-b-tooltip.hover
                            :title="$t('대시보드 추가')"
                        >
                            <i class="fas fa-plus"></i> {{ $t("추가") }}
                        </button>
                        <button class="btn btn-white" @click="onToggleEdit()">
                            <i class="fas fa-window-close"></i> {{ $t("닫기") }}
                        </button>
                    </div>
                </div>
            </div>
            <!-- 타이틀 및 서브페이지 탭 -->
            <div class="row m-b-4">
                <!-- 서브페이지 탭 -->
                <div class="col-lg-12">
                    <div class="dashboard-tab-area">
                        <div class="dashboard-tab-container" v-if="pageCount >= 1 || isEditMode">
                            <div class="dashboard-tab-wrapper">
                                <div
                                    v-for="(page, i) in viewSet.pages"
                                    :key="i"
                                    class="dashboard-tab-item"
                                    :class="{ 'dashboard-tab-active': tabIdx == i }"
                                    @click="toggleTabs(i)"
                                >
                                    <app-icon :icon="page.icon" class="dashboard-tab-icon" fallback="fa fa-question" />
                                    <span class="dashboard-tab-text d-none d-md-inline">
                                        {{ $t(page.title) }}
                                    </span>
                                    <i
                                        class="fas fa-edit dashboard-tab-edit"
                                        v-b-tooltip.hover
                                        :title="$t('대시보드 편집')"
                                        :class="{ 'dashboard-edit-active': tabIdx == i }"
                                        @click.stop="openEditPage(page, i)"
                                        v-if="isEditMode"
                                    ></i>
                                </div>
                                <!-- 커스텀 드롭다운을 탭 우측에 배치 -->
                                <div v-if="!isMobile && !isEditMode && showDocOption" class="custom-dropdown-container">
                                    <!-- 드롭다운 토글 버튼 -->
                                    <button
                                        class="custom-dropdown-toggle"
                                        @click="toggleCustomDropdown"
                                        :class="{ active: isCustomDropdownOpen }"
                                    >
                                        <i class="fas fa-cog"></i>
                                    </button>

                                    <!-- 커스텀 드롭다운 메뉴 -->
                                    <transition name="custom-dropdown">
                                        <div v-if="isCustomDropdownOpen" class="custom-dropdown-menu">
                                            <div
                                                class="custom-dropdown-item"
                                                @click="
                                                    onRefresh();
                                                    closeCustomDropdown();
                                                "
                                            >
                                                <i class="fas fa-redo"></i>
                                                <span>{{ $t("새로고침") }}</span>
                                            </div>

                                            <div
                                                class="custom-dropdown-item"
                                                @click="
                                                    onToggleEdit();
                                                    closeCustomDropdown();
                                                "
                                            >
                                                <i class="fas fa-edit"></i>
                                                <span>{{ $t("대시보드 편집") }}</span>
                                            </div>

                                            <div
                                                class="custom-dropdown-item"
                                                @click="
                                                    openStyleModal();
                                                    closeCustomDropdown();
                                                "
                                            >
                                                <i class="fas fa-palette"></i>
                                                <span>{{ $t("대시보드 스타일수정") }}</span>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                                <!-- 새 페이지 추가 버튼 -->
                                <button
                                    v-if="isEditMode"
                                    class="dashboard-tab-add"
                                    v-b-tooltip.hover
                                    :title="$t('대시보드 추가')"
                                    @click="onAddNewPage('xeWidgetPageV2')"
                                >
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>

                        <!-- 여기까지 -->
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- 타이틀 -->
                <div class="col-lg-12 dashboard-title-container">
                    <div class="pull-left" :class="{ 'w-100': isEditMode }">
                        <template v-if="isEditMode">
                            <valid-textarea
                                :vid="'대시보드 제목'"
                                :inputType="'text'"
                                :inputValue.sync="currentPage.title"
                                :classList="'xe-wg-input page-header'"
                                :rules="rules.DASHBOARD_MOTIFY_TITLE_RULE"
                                :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                                style="min-height: 30px"
                            ></valid-textarea>

                            <!-- <textarea
              type="text"
              class="xe-wg-input page-header"
              maxlength="100"
              placeholder="content here"
              style="min-height: 30px;"
              v-model="currentPage.title"
              v-on:keyup.enter="
                $event.target.nextElementSibling
                  ? $event.target.nextElementSibling.focus()
                  : null
              "
              v-on:keydown.up="
                $event.target.previousElementSibling
                  ? $event.target.previousElementSibling.focus()
                  : null
              "
              v-on:keydown.down="
                $event.target.nextElementSibling
                  ? $event.target.nextElementSibling.focus()
                  : null
              "
            ></textarea> -->
                        </template>
                        <!-- <template v-else>
                            <span class="current-page-title">
                                <app-icon :icon="currentPage.icon" />
                                {{ $t(currentPage.title) }}
                            </span>
                        </template> -->
                    </div>
                </div>
            </div>

            <!-- 위젯페이지 (모바일: 수평 스와이프로 이전/다음 탭) -->
            <div
                class="tab-content p-0"
                :class="{ 'tab-content--tab-swipe': tabSwipeEnabled }"
                v-if="isShow"
                @touchstart.passive="onTabContentTouchStart"
                @touchend.passive="onTabContentTouchEnd"
                @touchcancel.passive="onTabContentTouchCancel"
            >
                <div
                    v-for="(page, i) in viewSet.pages"
                    :key="i"
                    class="tab-pane fade"
                    :class="{ 'active show': tabIdx == i }"
                    @keydown.esc="onFullScreen(false)"
                >
                    <xe-widget-page-v2
                        ref="widgetV2"
                        v-if="tabIdx == i && page.type == 'xeWidgetPageV2'"
                        :page="page"
                    />
                </div>
            </div>

            <!-- 다른 이름으로 저장 팝업 -->
            <vvo v-slot="w">
                <b-modal ref="saveAsPopup" body-class="p-20" cancel-variant="default" :title="$t('다른 이름으로 저장')">
                    <div class="row form-group">
                        <div class="col-md-12">
                            <label>
                                <trans>저장할 새 대시보드 제목</trans>
                            </label>

                            <valid-input
                                :vid="'새 대시보드 제목'"
                                :inputType="'text'"
                                :inputValue.sync="saveAsViewCode"
                                :classList="'form-control'"
                                :rules="rules.DASHBOARD_MOTIFY_TITLE_RULE"
                                :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                            ></valid-input>
                        </div>
                    </div>
                    <template #modal-footer="{ cancel }">
                        <b-button size="sm" variant="danger" @click="cancel()"> 취소 </b-button>
                        <!-- Emulate built in modal footer ok and cancel button actions -->
                        <b-button size="sm" variant="primary" @click="onValidate(w, onSaveAs)"> 저장 </b-button>
                    </template>
                </b-modal>
            </vvo>
            <!-- 대시보드 추가 팝업 -->
            <b-modal ref="analysisModal" :hide-footer="true" :title="$t('대시보드 추가')">
                <analysis-detail @save-done="onAnalysisSaveDone"></analysis-detail>
            </b-modal>

            <!-- 페이지탭 속성 팝업 -->
            <b-modal ref="editPagePopup" cancel-variant="default" hide-footer :title="$t('대시보드 상세')">
                <div v-if="changePage">
                    <vvo v-slot="t">
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label>
                                    <trans>아이콘</trans>
                                </label>
                                <br />
                                <div class="icon-select-container">
                                    <icon-select
                                        :current="changePage.icon"
                                        @on-change="onChangeIcon"
                                        :preview-style-config="{ border: '1px solid #d5dbe0' }"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-12">
                                <label>
                                    <trans>제목</trans>
                                </label>
                                <valid-input
                                    :vid="'제목'"
                                    :inputType="'text'"
                                    :inputValue.sync="changePage.title"
                                    :rules="rules.DASHBOARD_NEW_TITLE_RULE"
                                    :errorMessage="validMessage.COMMON_BOTH_LENGTH_VALID_MESSAGE(1, 30)"
                                ></valid-input>
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>
                                    <trans>시간유형</trans>
                                </label>
                                <select class="form-control" v-model="changePage.search.timeType">
                                    <option :value="5">{{ $t("분") }}</option>
                                    <option :value="4">{{ $t("시") }}</option>
                                    <option :value="3">{{ $t("일") }}</option>
                                    <option :value="2">{{ $t("월") }}</option>
                                    <option :value="1">{{ $t("년") }}</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>&nbsp;</label>
                                <div class="checkbox checkbox-css">
                                    <input
                                        type="checkbox"
                                        :id="'editPagesPopup_isLoadSearch'"
                                        v-model="changePage.search.isLoadSearch"
                                    />
                                    <label :for="'editPagesPopup_isLoadSearch'">
                                        <trans>화면 로드시 조회</trans>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <div class="checkbox checkbox-css">
                                    <input
                                        type="checkbox"
                                        :id="'editPagesPopup_display'"
                                        v-model="changePage.search.display"
                                    />
                                    <label :for="'editPagesPopup_display'">
                                        <trans>조회상자 사용</trans>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="checkbox checkbox-css">
                                    <input
                                        type="checkbox"
                                        :id="'editPagesPopup_isCompare'"
                                        v-model="changePage.search.isCompare"
                                    />
                                    <label :for="'editPagesPopup_isCompare'">
                                        <trans>비교조회모드 사용</trans>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div slot="modal-footer" class="w-100">
                            <button class="btn btn-sm pull-right btn-primary" @click="onValidate(t, onUpdatePage)">
                                <i class="fas fa-save"></i>
                                <trans>확인</trans>
                            </button>
                            <button
                                class="btn btn-sm pull-left btn-danger"
                                @click="onRemovePage(changePage, changeIdx)"
                            >
                                <i class="fas fa-times"></i>
                                <trans>삭제</trans>
                            </button>
                        </div>
                    </vvo>
                </div>
            </b-modal>

            <!-- 대시보드 스타일 수정 팝업 -->
            <b-modal ref="styleModal" cancel-variant="default" :title="$t('대시보드 스타일수정')" size="md">
                <div class="style-modal-content">
                    <div class="color-palette-section">
                        <div class="palette-group">
                            <h6 class="palette-title">
                                <i class="fas fa-paint-brush mr-2"></i>
                                <trans>위젯 타이틀 배경색</trans>
                            </h6>
                            <energy-color-palette v-model="widgetStyle.titleColor" :energy-type="'renewable'" />
                        </div>

                        <div class="palette-group">
                            <h6 class="palette-title">
                                <i class="fas fa-font mr-2"></i>
                                <trans>위젯 타이틀 폰트색</trans>
                            </h6>
                            <energy-color-palette v-model="widgetStyle.fontColor" :energy-type="'electricity'" />
                        </div>
                    </div>

                    <div class="background-image-section">
                        <h6 class="palette-title">
                            <i class="fas fa-image mr-2"></i>
                            <trans>대시보드 배경 이미지</trans>
                        </h6>
                        <div class="background-image-grid">
                            <div
                                v-for="(img, index) in galleryImages"
                                :key="index"
                                class="background-image-item"
                                :class="{ selected: widgetStyle.backgroundImage === img }"
                                @click="selectBackgroundImage(img)"
                            >
                                <img :src="img" :alt="'gallery-' + (index + 1)" />
                                <div class="selected-overlay" v-if="widgetStyle.backgroundImage === img">
                                    <i class="fas fa-check"></i>
                                </div>
                            </div>
                            <div
                                class="background-image-item no-image"
                                :class="{ selected: !widgetStyle.backgroundImage }"
                                @click="selectBackgroundImage('')"
                            >
                                <i class="fas fa-ban"></i>
                                <span>없음</span>
                            </div>
                        </div>
                    </div>

                    <div class="preview-section">
                        <h6 class="preview-title">
                            <i class="fas fa-eye mr-2"></i>
                            <trans>미리보기</trans>
                        </h6>
                        <div
                            class="widget-preview"
                            :style="{
                                backgroundColor: widgetStyle.titleColor,
                                color: widgetStyle.fontColor,
                            }"
                        >
                            <span class="preview-text">위젯 타이틀 예시</span>
                        </div>
                    </div>
                </div>

                <template #modal-footer="{ cancel }">
                    <div class="modal-footer-buttons">
                        <b-button size="sm" variant="outline-secondary" @click="onCancelStyle(cancel)">
                            <i class="fas fa-times mr-1"></i>
                            <trans>취소</trans>
                        </b-button>
                        <b-button size="sm" variant="primary" @click="onSaveStyle">
                            <i class="fas fa-save mr-1"></i>
                            <trans>저장</trans>
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </vvo>
        <Welcome class="welcome" v-if="showWelcome" @close="closeWelcome" />
    </div>
</template>

<script>
//import PageOptions from "../../config/PageOptions.vue";
import backEndApi from "@api/backEndApi.js";
import xeWidgetPageV2 from "./WidgetPageV2.vue";
import AnalysisDetail from "@src/views/sys/analysisView/visual/AnalysisDetail.vue";
import AppErrorHandler from "@src/appErrorHandler";
import EnergyColorPalette from "@src/components/colorpalette/EnergyColorPalette.vue";

import * as rules from "@src/consts/ruleConsts.js";
import * as validMessage from "@src/consts/validMessageConsts.js";
import * as popupMessages from "@src/consts/popupMessageConsts";
import Welcome from "@src/views/Welcome.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    components: {
        xeWidgetPageV2,
        AnalysisDetail,
        Welcome,
        EnergyColorPalette,
    },
    props: ["initViewCode"],
    data() {
        return {
            //pageOptions: PageOptions,
            showDocOption: true, //
            isShow: true,
            viewCode: this.$route.params.viewCode,
            viewSet: {},
            originPage: {},
            tabIdx: 0,
            saveAsViewCode: "",
            newViewCode: "",

            changePage: null,
            changeIdx: -1,

            //to: null,

            widget_property_box_width: 300,
            widgetStyle: {
                titleColor: "", // 기본 배경색
                fontColor: "", // 기본 폰트색
                backgroundImage: "", // 배경 이미지 경로
            },
            // gallery 이미지 총 개수 (gallery-1.jpg ~ gallery-70.jpg)
            galleryImageCount: 70,
            isCustomDropdownOpen: false, // 커스텀 드롭다운 상태
            rules,
            validMessage,
            popupMessages,

            tabSwipeStartX: null,
            tabSwipeStartY: null,
        };
    },
    created() {
        console.log(this);
    },
    computed: {
        ...mapState(["showWelcome"]),
        ...mapGetters(["getWidgetStyle", "isEditMode"]),

        isFullScreen() {
            return this.pageOptions.pageEmpty;
        },
        docStyle() {
            // 수정모드때 perperty-bar 300px 만큼..
            if (this.isEditMode)
                return {
                    width: "100%",
                };

            return this.isFullScreen && this.currentPage.width ? { " width": this.currentPage.width } : "{}";
        },
        pageCount() {
            if (this.viewSet && this.viewSet.pages) return this.viewSet.pages.length;
            return 0;
        },
        currentPage() {
            if (this.viewSet && this.viewSet.pages && this.viewSet.pages.length > this.tabIdx) {
                return this.viewSet.pages[this.tabIdx];
            }
            return {};
        },
        widgetTitleColorStyle() {
            return {
                "--widget-title-color": this.getWidgetStyle.titleColor,
                "--widget-font-color": this.getWidgetStyle.fontColor,
            };
        },
        // gallery 이미지 리스트 동적 생성 (thumb 제외, gallery-{n}.jpg 패턴만)
        galleryImages() {
            return Array.from({ length: this.galleryImageCount }, (_, i) => `/assets/img/gallery/gallery-${i + 1}.jpg`);
        },
        /** 모바일에서 탭 영역 스와이프 전환 활성화 */
        tabSwipeEnabled() {
            return !this.isEditMode && this.pageCount > 1;
        },
    },
    async mounted() {
        if (this.initViewCode) this.viewCode = this.initViewCode;
        await this.initSetting();

        // 저장된 위젯 스타일 불러오기
        const savedStyle = this.getWidgetStyle;
        if (savedStyle) {
            this.widgetStyle = { ...savedStyle };
        }

        // 외부 클릭 시 드롭다운 닫기
        document.addEventListener("click", this.handleOutsideClick);
    },
    beforeRouteLeave(to, from, next) {
        this.pageOptions.pageEmpty = false;
        //clearInterval(this.to);
        next();
    },
    beforeDestroy() {
        //clearInterval(this.to);
        document.removeEventListener("click", this.handleOutsideClick);
    },
    watch: {
        "$route.params.viewCode": async function (newV) {
            if (this.initViewCode) return;
            this.viewCode = newV;
            await this.initSetting();
        },
    },
    methods: {
        ...mapMutations(["SET_SHOW_WELCOME", "UPDATE_EDIT_MODE", "UPDATE_TOOLBAR", "SET_WIDGET_STYLE"]),
        // ────────────────────────────────────────────────────────────────
        // 대시보드 config 는 "레이아웃 + 바인딩 키"만 저장한다.
        //  - equipTypeInfo·currentEquipStatus·nodeInfo.children 는 바인딩 키(sysNodeIdx·
        //    equipType)로 런타임에 재생성 가능한 파생 데이터라 저장하지 않는다.
        //    (위젯마다 중복되어 페이로드가 수 MB 로 불어나 nginx 413 발생했음)
        //  - 위젯(xeEquipmentControl)은 mount 시 공유 캐시(equipMetaCache)에서 직접 로드한다.
        //  - 아래 함수는 저장 직전(파생 블록 제거) + 로드 직후(레거시 문서 마이그레이션) 공용.
        // ────────────────────────────────────────────────────────────────
        stripWidgetRuntime(viewSet) {
            const clone = JSON.parse(JSON.stringify(viewSet));

            (clone.pages || []).forEach((page) => {
                (page.widgets || []).forEach((widget) => {
                    delete widget.equipTypeInfo;
                    delete widget.currentEquipStatus;
                    if (widget.nodeInfo) {
                        delete widget.nodeInfo.children;
                    }
                });
            });

            return clone;
        },
        customValidate() {
            const hasEmptyTitle = this.viewSet?.pages.some((view) => !view.title || view.title.trim().length === 0);
            if (hasEmptyTitle) {
                this.alertNoti("대시보드 제목을 입력하세요.");
                return false;
            } else {
                return true;
            }
        },
        closeWelcome() {
            this.SET_SHOW_WELCOME(false);
        },

        async initSetting() {
            if (this.isShow == false) return;
            this.isShow = false; // 진행중

            this.tabIdx = 0;
            this.saveAsViewCode = "";
            this.newViewCode = "";

            // TODO: 일반화면 메뉴에서 로고를 눌렀을때 대시보드이 표시되지 않음..
            // this.$route.params.viewCode     "/" 경로만 표시됨..

            if (this.isEmpty(this.viewCode)) {
                console.warn("viewCode is empty..", this.$route);
                return;
            }

            // 현재 페이지의 viewCode와 동작중인 viewCode가 같이 않으면 리턴한다.
            if (this.viewCode !== this.$route.params.viewCode) {
                return;
            }

            await this._initViewCode();
        },
        async _initViewCode() {
            // console.log(this.viewCode);
            // template 미리 보기 작업 해야함

            // backEndApi.visual.getViewSet(this.viewCode).then((res) => {
            // 	console.log(res);

            // 	if (this.$err(res.data)) return;

            // 	let data = res.data;
            // 	if (!data.hasOwnProperty("pages") || data.pages.length <= 0) {
            // 		return;
            // 	}

            // 	data.pages.forEach((page, i) => {
            // 		// cellSize 고정 - 화면크기에 따라 변경되도록 수정되어, 기본값 10으로 고정됨...
            // 		page.cellSize = { w: 10, h: 10, margin: 0 };

            // 		if (page.widgets) {
            // 			page.widgets.forEach((widget, j) => {
            // 				widget.i = widget.id = `W${(i + 1).pad(3)}-${(j + 1).pad(3)}`;

            // 				if (this.isEmpty(widget.position)) {
            // 					widget.position = { x: (j % 4) * 10, y: j * 2, w: 20, h: 20 };
            // 				}
            // 			});
            // 		}
            // 	});

            // 	this.viewSet = data;

            // 	/** 저장 혹은 닫기 시 데이터 복원 등을 위해서 변수 추가 */
            // 	this.originPage = JSON.stringify(data);
            // 	this.isShow = true;
            // });

            /*
                ↓↓↓↓↓
            */

            try {
                const res = await backEndApi.visual.getViewSet(this.viewCode);

                let data = res.data;
                if (!data.hasOwnProperty("pages") || data.pages.length <= 0) {
                    return;
                }

                data.pages.forEach((page, i) => {
                    // cellSize 고정 - 화면크기에 따라 변경되도록 수정되어, 기본값 10으로 고정됨...
                    page.cellSize = { w: 10, h: 10, margin: 0 };

                    if (page.widgets) {
                        page.widgets.forEach((widget, j) => {
                            widget.i = widget.id = `W${(i + 1).pad(3)}-${(j + 1).pad(3)}`;

                            if (this.isEmpty(widget.position)) {
                                widget.position = { x: (j % 4) * 10, y: j * 2, w: 20, h: 20 };
                            }
                        });
                    }
                });

                // 레거시 문서에 파생 블록이 박혀 있으면 제거(마이그레이션). 위젯이 런타임에 직접 로드한다.
                this.viewSet = this.stripWidgetRuntime(data);

                /** 저장 혹은 닫기 시 데이터 복원 등을 위해서 변수 추가 */
                this.originPage = JSON.stringify(this.viewSet);
                this.isShow = true;
            } catch (err) {
                new AppErrorHandler(err).printErrorLog(true);
            }
        },
        // 페이지 전체 save
        async onSave(skipConfirm = false, alertMessage) {
            // this.alertQuestion(popupMessages.DASHBOARD_SAVE_POPUP_MESSAGE).then((result) => {
            // 	if (!result.value) return;

            // 	let param = { viewCode: this.viewCode, option: this.viewSet };

            // 	backEndApi.visual.saveViewSet(param).then(({ data }) => {
            // 		if (this.$err(data)) return;

            // 		this.alertNoti(`${popupMessages.DASHBOARD_SAVE_SUCCESS_POPUP_MESSAGE}`);

            //     this.originPage = JSON.stringify(this.viewSet);
            // 	});
            // });

            /*
                ↓↓↓↓↓
            */

            try {
                if (!skipConfirm) {
                    const result = await this.alertQuestion(popupMessages.DASHBOARD_SAVE_POPUP_MESSAGE);
                    if (!result.value) return;
                }
                let param = { viewCode: this.viewCode, option: this.stripWidgetRuntime(this.viewSet) };

                await backEndApi.visual.saveViewSet(param);

                await this.alertNoti(alertMessage ?? popupMessages.COMMON_SAVE_POPUP_MESSAGE);
                this.originPage = JSON.stringify(this.viewSet);

                this.onRefresh();
            } catch (err) {
                new AppErrorHandler(err).printErrorLog(true);

                return;
            }
        },
        openSaveAsPopup() {
            this.$refs.saveAsPopup.show();
        },
        // 새로운 대시보드 추가
        openAnalysisModal() {
            this.$refs.analysisModal.show();
        },
        onAnalysisSaveDone(newViewCode) {
            this.$refs.analysisModal.hide();

            // 페이지 새로 생성시 해당 페이지로 이동
            this.$router.push({ path: `/visual/analysis/${newViewCode}` });
        },
        // 페이지 전체 save as
        async onSaveAs() {
            // this.alertQuestion(popupMessages.DASHBOARD_SAVE_POPUP_MESSAGE).then((result) => {
            // 	if (!result.value) return;

            // 	let param = {
            // 		viewCode: this.saveAsViewCode,
            // 		option: JSON.parse(JSON.stringify(this.viewSet)),
            // 	};

            // 	backEndApi.visual.saveAsViewSet(param).then(({ data }) => {
            // 		if (this.$err(data)) {
            // 			// TODO: 어떤 오류인지 알지 못하는데.. 오류메세지를 어떻게???
            // 			// this.notiBottom("이미 존재하는 파일입니다. 다시 시도해주세요.");
            // 			return;
            // 		}

            // 		this.$nextTick(() => {
            // 			this.alertNoti(`${popupMessages.DASHBOARD_SAVE_SUCCESS_POPUP_MESSAGE}`);
            // 			this.originPage = JSON.stringify(this.viewSet);
            // 		});

            // 		this.$router.push({
            // 			path: `/visual/analysis/${this.saveAsViewCode}`,
            // 		});
            // 	});
            // });

            /*
                ↓↓↓↓↓
            */

            try {
                const result = await this.alertQuestion(popupMessages.DASHBOARD_SAVE_POPUP_MESSAGE);
                if (!result.value) return;

                let param = {
                    viewCode: this.saveAsViewCode,
                    option: this.stripWidgetRuntime(this.viewSet),
                };

                await backEndApi.visual.saveAsViewSet(param);

                this.$nextTick(async () => {
                    await this.alertNoti(popupMessages.COMMON_SAVE_POPUP_MESSAGE);
                    this.originPage = JSON.stringify(this.viewSet);
                });

                this.$router.push({
                    path: `/visual/analysis/${this.saveAsViewCode}`,
                });
            } catch (err) {
                new AppErrorHandler(err).printErrorLog(true);
            }
        },
        // tab
        toggleTabs(idx) {
            this.tabIdx = idx;
        },

        onTabContentTouchStart(e) {
            console.log("onTabContentTouchStart", e);
            if (!this.tabSwipeEnabled) return;
            const t = e.touches && e.touches[0];
            if (!t) return;
            this.tabSwipeStartX = t.clientX;
            this.tabSwipeStartY = t.clientY;
        },

        onTabContentTouchEnd(e) {
            if (!this.tabSwipeEnabled) return;
            const startX = this.tabSwipeStartX;
            const startY = this.tabSwipeStartY;
            this.tabSwipeStartX = null;
            this.tabSwipeStartY = null;
            if (startX == null || startY == null) return;

            const t = e.changedTouches && e.changedTouches[0];
            if (!t || !this.viewSet?.pages?.length) return;

            const dx = t.clientX - startX;
            const dy = t.clientY - startY;

            const threshold = 56;
            if (Math.abs(dx) < threshold) return;
            if (Math.abs(dx) <= Math.abs(dy)) return;

            const n = this.viewSet.pages.length;
            if (dx < 0) {
                this.toggleTabs((this.tabIdx + 1) % n);
            } else {
                this.toggleTabs((this.tabIdx - 1 + n) % n);
            }
        },

        onTabContentTouchCancel() {
            this.tabSwipeStartX = null;
            this.tabSwipeStartY = null;
        },
        openEditPage(page, i) {
            this.changePage = Object.assign({}, page);
            this.changeIdx = i;
            this.$refs.editPagePopup.show(); // 팝업띄우기..
        },
        onAddNewPage(pageType) {
            let newPage = {
                type: pageType, // "xeWidgetPageV2",
                title: this.$t("빈 제목"),
                icon: "fa fa-chart-bar",
                search: {
                    isCompare: false,
                    timeType: 3,
                    isLoadSearch: false,
                    display: true,
                },
                widgets: [],
            };

            this.viewSet.pages.push(newPage);
        },
        // Page 속성 수정팝업
        onChangeIcon(value) {
            this.changePage.icon = null;
            if (!this.isEmpty(value)) this.changePage.icon = value.icon;
            // 페이지속성 팝업에서 아이콘을 수정하였을때
        },
        onUpdatePage() {
            let cur = this.viewSet.pages[this.changeIdx];

            cur.title = this.changePage.title;
            cur.icon = this.changePage.icon;
            cur.search = {
                isCompare: this.changePage.search.isCompare,
                timeType: this.changePage.search.timeType,
                isLoadSearch: this.changePage.search.isLoadSearch,
                display: this.changePage.search.display,
            };

            this.$refs.editPagePopup.hide();
        },
        onRemovePage(page, pageIdx) {
            console.log(page, pageIdx, this.viewSet.pages);

            if (this.viewSet.pages.length <= 1) {
                this.alertDanger(popupMessages.DASHBOARD_DELETE_LESS_THAN_ONE_MESSAGE);
                return;
            }

            this.alertConfirmWarning(popupMessages.DASHBOARD_DELETE_POPUP_MESSAGE).then((result) => {
                if (!result.value) return;

                this.viewSet.pages.splice(pageIdx, 1);
                // this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);

                // 대시보드 삭제 후 저장
                this.onSave(true, "삭제하였습니다.");
                // 대시보드 삭제 후 이전 대시보드로 이동
                if (this.tabIdx === 0) {
                    this.alertNoti("더이상 대시보드가 없습니다.");
                } else {
                    this.tabIdx -= 1;
                }
                this.$refs.editPagePopup.hide();
            });
        },
        // 추가기능 버튼
        onRefresh() {
            console.log(this.$refs);

            if (this.$refs.widget && this.$refs.widget[this.tabIdx]) this.$refs.widget[this.tabIdx].onRefresh();

            if (this.$refs.widgetV2 && this.$refs.widgetV2[this.tabIdx]) {
                setTimeout(() => {
                    this.$refs.widgetV2[this.tabIdx].onRefresh();
                }, 500);
            }

            if (this.$refs.widgetV3 && this.$refs.widgetV3[this.tabIdx]) {
                this.$refs.widgetV3[this.tabIdx].onRefresh();
            }
        },
        onToggleEdit() {
            // console.log(this.viewSet., this.originPage);
            // console.log(this.viewSet.pages[0].widgets[9].chart, JSON.parse(this.originPage).pages[0].widgets[9].chart);
            let is = !this.isEditMode;
            this.UPDATE_EDIT_MODE(is);
            this.UPDATE_TOOLBAR(is);
            this.viewSet = JSON.parse(this.originPage);
            this.onRefresh();
        },
        onToggleFullScreen() {
            this.pageOptions.pageEmpty = !this.pageOptions.pageEmpty;
        },
        onFullScreen(isFull) {
            this.pageOptions.pageEmpty = isFull;
        },
        onPropertyBoxWidth(w) {
            this.widget_property_box_width = w;
        },
        openStyleModal() {
            // 저장된 스타일이 있으면 불러오기
            const savedStyle = this.getWidgetStyle;
            if (savedStyle) {
                this.widgetStyle = { ...savedStyle };
            }
            this.$refs.styleModal.show();
        },

        onSaveStyle() {
            // 스타일 저장 - 이때만 스토어에 저장
            this.SET_WIDGET_STYLE(this.widgetStyle);
            this.$refs.styleModal.hide();
            this.alertNoti("스타일이 저장되었습니다.");
        },
        onCancelStyle(cancel) {
            // 취소 시 기존 값으로 되돌리기
            const savedStyle = this.getWidgetStyle;
            this.widgetStyle = { ...savedStyle };
            cancel();
        },
        selectBackgroundImage(img) {
            this.widgetStyle.backgroundImage = img;
        },

        // 커스텀 드롭다운 관련 메서드
        toggleCustomDropdown() {
            this.isCustomDropdownOpen = !this.isCustomDropdownOpen;
        },

        closeCustomDropdown() {
            this.isCustomDropdownOpen = false;
        },

        handleOutsideClick(event) {
            const dropdownContainer = this.$el.querySelector(".custom-dropdown-container");
            if (dropdownContainer && !dropdownContainer.contains(event.target)) {
                this.closeCustomDropdown();
            }
        },
    },
};
</script>

<style scoped>
.dashboard-title-container {
    display: flex;
    align-items: center;
}

.icon-select-container {
    height: 50%;
    width: 100%;
}
.current-page-title {
    font-size: 17px;
    font-weight: 600;
    color: #99adc4;
    margin-left: 12px;
}

.dashboard-edit-active {
    color: white !important;
}

.dashboard-tab-area {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 9px;
    gap: 12px;
}

/* 대시보드 탭 스타일링 */
.dashboard-tab-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
}

.dashboard-tab-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f8f9fa;
    border-radius: 20px;
    padding: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #e9ecef;
}

.dashboard-tab-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 3px 6px;
    background: transparent;
    border: 2px solid transparent;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    justify-content: center;
    font-weight: 500;
    color: #6c757d;
}

.dashboard-tab-item:hover {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.dashboard-tab-item.dashboard-tab-active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
    box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
    transform: translateY(-1px);
}

.dashboard-tab-icon {
    font-size: 14px;
    width: 16px;
    text-align: center;
    transition: all 0.3s ease;
}

.dashboard-tab-text {
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
    transition: all 0.3s ease;
}

.dashboard-tab-edit {
    position: relative;
    font-size: 13px;
    color: #adb5bd;
    cursor: pointer;
    margin: 0 6px;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.dashboard-tab-edit:hover {
    background: rgba(59, 130, 246, 0.2);
    color: #3b82f6;
}

.dashboard-tab-add {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #10b981, #059669);
    border: none;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin-left: 8px;
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    position: relative;
    overflow: hidden;
}

.dashboard-tab-add:focus {
    border: none;
    outline: none;
}

.dashboard-tab-add::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transition: all 0.3s ease;
    transform: translate(-50%, -50%);
}

.dashboard-tab-add:hover::before {
    width: 100%;
    height: 100%;
}

.dashboard-tab-add:hover {
    transform: scale(1.1) rotate(90deg);
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
}

.dashboard-tab-add i {
    font-size: 14px;
    font-weight: 600;
    position: relative;
    z-index: 1;
}

/* 커스텀 드롭다운 스타일 - 탭과 어울리게 수정 */
.custom-dropdown-container {
    position: relative;
    display: flex;
    align-items: center;
}

.custom-dropdown-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 50%;
    color: #6c757d;
    cursor: pointer;
    transition:
        background-color 0.25s ease,
        color 0.25s ease,
        transform 0.25s ease,
        box-shadow 0.25s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    font-size: 12px;
    will-change: transform, box-shadow;
}

.custom-dropdown-toggle:hover {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.custom-dropdown-toggle.active {
    background: #3b82f6;
    color: white;
    border-color: #3b82f6;
    box-shadow:
        0 4px 15px rgba(59, 130, 246, 0.3),
        0 0 0 3px rgba(59, 130, 246, 0.15);
}

.custom-dropdown-toggle:focus {
    border: none;
    outline: none;
}

/* 포커스 접근성 링 */
.custom-dropdown-toggle:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
}

/* 기어 아이콘 애니메이션으로 탭 UI와 조화 */
.custom-dropdown-toggle i {
    transition:
        transform 0.25s ease,
        color 0.2s ease;
}

.custom-dropdown-toggle:hover i,
.custom-dropdown-toggle.active i {
    transform: rotate(90deg);
}

.custom-dropdown-menu {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 180px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    z-index: 9999;
    overflow: hidden;
}

.custom-dropdown-item {
    padding: 7px 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    border-bottom: 1px solid #f3f4f6;
}

.custom-dropdown-item:last-child {
    border-bottom: none;
}

.custom-dropdown-item:hover {
    background-color: #f9fafb;
    color: #3b82f6;
}

.custom-dropdown-item i {
    width: 16px;
    text-align: center;
    color: #6b7280;
    transition: color 0.2s ease;
}

.custom-dropdown-item:hover i {
    color: #3b82f6;
}

.custom-dropdown-item span {
    flex: 1;
}

/* 커스텀 드롭다운 애니메이션 */
.custom-dropdown-enter-active,
.custom-dropdown-leave-active {
    transition: all 0.2s ease;
}

.custom-dropdown-enter,
.custom-dropdown-leave-to {
    opacity: 0;
    transform: translateY(-4px);
}

.custom-dropdown-enter-to,
.custom-dropdown-leave {
    opacity: 1;
    transform: translateY(0);
}

/* 추가적인 호버 효과 */
.custom-dropdown-item {
    position: relative;
}

.selected-tab {
    background-color: #767778;
    color: white;
    border-radius: 20px;
}

.dashboard-tab {
    background-color: #f8f9fa;
    border-radius: 20px;
    padding: 5px;
}

/* tab-content 배경색 */
.panel {
    background-color: rgba(0, 0, 0, 0);
}

.tab-content--tab-swipe {
    touch-action: pan-y;
    height: 100vh;
}

/* dnd */
.xe-drop-me {
    min-height: 50px;
    background-color: whitesmoke;
}

[draggable] {
    cursor: pointer;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}

li {
    color: black;
}

.dragging {
    opacity: 0.8;
    color: #6894d1;
}

.drag-over {
    outline: 1px solid red;
}

.drag-enter {
    color: #c93742;
}

/* 동작하지 않음.. */
.dropdown-menu {
    left: -52px !important;
}

.welcome {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    z-index: 9999;

    background-color: white;

    transition: opacity 0.5s ease;
    opacity: 1;
}

.style-modal-content {
    padding: 0;
}

.color-palette-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.palette-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.palette-title {
    color: #495057;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.preview-section {
    border-top: 1px solid #e9ecef;
    padding-top: 20px;
    margin-top: 20px;
}

.preview-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.widget-preview {
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.preview-text {
    font-weight: 600;
    font-size: 14px;
}

.modal-footer-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

/* 배경 이미지 선택 섹션 */
.background-image-section {
    border-top: 1px solid #e9ecef;
    padding-top: 20px;
    margin-top: 20px;
}

.background-image-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    max-height: 250px;
    overflow-y: auto;
    padding: 5px;
}

.background-image-item {
    position: relative;
    aspect-ratio: 16 / 10;
    border-radius: 8px;
    cursor: pointer;
    border: 3px solid transparent;
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.background-image-item:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.background-image-item.selected {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}

.background-image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.background-image-item .selected-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(59, 130, 246, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.background-image-item .selected-overlay i {
    color: white;
    font-size: 24px;
}

.background-image-item.no-image {
    background: #f1f5f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    color: #94a3b8;
}

.background-image-item.no-image i {
    font-size: 20px;
}

.background-image-item.no-image span {
    font-size: 11px;
    font-weight: 600;
}

.background-image-item.no-image.selected {
    background: #e0f2fe;
    color: #3b82f6;
}
</style>
